import { addClass, removeClass, hasClass, toggleClass } from "../common/Utils";

export default class Layer {
    constructor(){
        this.addEvents();
    }

    addEvents(){
        document.querySelector('body')?.addEventListener('click', e =>{
            Layer.closeLayer();
        });
    }

    static closeLayer(){
        const toggleEl : HTMLElement | null = document.querySelector('.is-show-footer');
        if(toggleEl){
            removeClass(toggleEl, 'is-show-footer');
        }
    }

    static toggleLayer( _myId: string):void {
        const isShowEl : HTMLElement | null = document.getElementById(_myId);

        if( isShowEl ){
            if( !hasClass(isShowEl, 'is-show-footer') ){
                Layer.closeLayer();
            }
            toggleClass(isShowEl, 'is-show-footer');
        }
    }
} // end of class